const PREFS_KEY = "fish_room_print_receipt"

/** @returns {boolean} */
export function readPrintProcessingReceiptPref() {
    try {
        const raw = window.localStorage.getItem(PREFS_KEY)
        if (raw == null) {
            return false
        }
        return raw === "true"
    } catch {
        return false
    }
}

/** @param {boolean} enabled */
export function writePrintProcessingReceiptPref(enabled) {
    try {
        window.localStorage.setItem(PREFS_KEY, enabled ? "true" : "false")
    } catch {
        // ignore storage errors
    }
}
